/** Pending assistant stream — incomplete-token cache + tail (fade alone is not typewriter). */
export const ASSISTANT_STREAMING = {
  hasNextChunk: true,
  enableAnimation: true,
  animationConfig: { fadeDuration: 160, easing: 'ease-out' as const },
  tail: true,
};
